export function findContent(state) {
  return (id) => state.all.find(((v) => v.id === id));
}
